<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      {{ weapon.name }} - {{ item.type }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-tooltip top color="success" v-model="copied">
        <template v-slot:activator="{ attrs }">
          <v-text-field
            label="Code"
            :value="item.code"
            readonly
            outlined
            v-bind="attrs"
            append-outer-icon="fa fa-copy"
            @click:append-outer="copyCode"
          />
        </template>
        <span>Kopiert!</span>
      </v-tooltip>
      <div v-if="!image" style="position: relative">
        <v-skeleton-loader type="image"> </v-skeleton-loader>
        <span
          style="
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          "
        >
          Kein Bild gefunden.
        </span>
      </div>
      <v-img v-else :src="image" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script lang="ts">
import DFWeapon from "@/shared/DFWeapon";
import DFWeaponBuild from "@/shared/DFWeaponBuild";
import Vue, { PropType } from "vue";
export default Vue.extend({
  name: "WeaponBuildItem",
  props: {
    item: {
      type: Object as PropType<DFWeaponBuild>,
      required: true,
    },
    weapons: {
      type: Array as PropType<DFWeapon[]>,
      required: true,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    image(): string {
      return `/api/df/weaponbuilds/${this.item.id}/image`;
    },
    weapon(): DFWeapon {
      return this.weapons.find((w) => w.id === this.item.weaponId) as DFWeapon;
    },
  },
  methods: {
    copyCode() {
      this.copied = true;
      navigator.clipboard.writeText(this.item.code);
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
  },
});
</script>
